import type { PasswordParams } from '@/domain/account/Account'
import type { AccountRepository } from '@/domain/account/AccountRepository'
import { getPasswordError } from '@/domain/auth/validation/validatePassword'
import type { AgentId } from '@/domain/shared/Brand'
import type { AccountService } from './AccountService'

/**
 * 账号服务的默认实现
 */
export class DefaultAccountService implements AccountService {
  constructor(private readonly accountRepository: AccountRepository) {}

  async getProfile(agentId: AgentId) {
    return this.accountRepository.getProfile(agentId)
  }

  async updateNickname(agentId: AgentId, nickname: string): Promise<void> {
    const trimmedNickname = nickname.trim()

    if (!trimmedNickname) {
      throw new Error('Nickname is required')
    }

    if (trimmedNickname.length < 2) {
      throw new Error('Nickname must be at least 2 characters')
    }

    return this.accountRepository.updateNickname(agentId, trimmedNickname)
  }

  async updatePassword(
    agentId: AgentId,
    params: PasswordParams,
  ): Promise<void> {
    if (!params.oldPassword) {
      throw new Error('Old password is required')
    }

    if (!params.newPassword) {
      throw new Error('New password is required')
    }

    const passwordError = getPasswordError(params.newPassword)
    if (passwordError) {
      throw new Error(passwordError)
    }

    if (params.newPassword === params.oldPassword) {
      throw new Error('New password cannot be the same as the current password')
    }

    if (params.newPassword !== params.confirmPassword) {
      throw new Error('Passwords do not match')
    }

    return this.accountRepository.updatePassword(agentId, params)
  }
}
